import { useEffect, useState } from 'react';

import UserContract from '../../../../Model/UserContract';
import useComponentMounted from '../../../../hooks/useComponentMounted';
import { reportError } from '../utils/reportError';

export const useBaseContracts = (coachId) => {
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const isMountedRef = useComponentMounted();

  useEffect(() => {
    if (!coachId) {
      setDocs([]);
      setError(false);
      setLoading(false);
      return undefined;
    }

    let cancelled = false;
    setDocs([]);
    setLoading(true);
    setError(false);

    (async () => {
      try {
        const collection = await UserContract.getBaseContractsByCoach(coachId);
        if (cancelled || !isMountedRef.current) return;
        const sorted = [...collection.docs].sort(
          (a, b) => (b.createdAt?.toMillis() ?? 0) - (a.createdAt?.toMillis() ?? 0),
        );
        setDocs(sorted);
      } catch (err) {
        reportError('loadContracts', err);
        if (!cancelled && isMountedRef.current) setError(true);
      } finally {
        if (!cancelled && isMountedRef.current) setLoading(false);
      }
    })();

    return () => { cancelled = true; };
  }, [coachId, isMountedRef]);

  return { docs, loading, error };
};
